import { useMemo } from "react";
import { getPortfolioReportingSummaryQuery } from "web_myplann/Api/Portfolio/getPortfolioReportingSummaryQuery";
import { usePortfolioListQuery } from "web_myplann/Api/Portfolio/usePortfolioListQuery";
import { usePropertyListQuery } from "web_myplann/Api/Portfolio/usePropertyListQuery";
import {
	ClientPortfolioDomainEnum,
	type PortfolioReportingOverviewTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { specialPortfolioListDomains } from "web_myplann/Portfolio/Pages/PortfolioListPage";

export const useDashboardDetailData = (
	overviewType: PortfolioReportingOverviewTypeEnum | undefined,
) => {
	const filterDatagroups = overviewType ? [overviewType] : undefined;
	const { data: portfolios, isLoading: isPortfoliosLoading } =
		usePortfolioListQuery(filterDatagroups, true, !!overviewType);
	const { data: properties, isLoading: isPropertiesLoading } =
		usePropertyListQuery(filterDatagroups, true, !!overviewType);

	const specialPortfolioListIds = useMemo(() => {
		if (!portfolios?.data) return [];
		return portfolios.data
			.filter(
				(p) =>
					p.domain !== undefined &&
					p.domain !== null &&
					(specialPortfolioListDomains.includes(p.domain) ||
						p.domain === ClientPortfolioDomainEnum.LifeInsurance),
			)
			.map((p) => p.id);
	}, [portfolios?.data]);

	const { data: reporting } = getPortfolioReportingSummaryQuery(
		specialPortfolioListIds,
		filterDatagroups,
	);

	const hasData = !!(portfolios?.data || properties?.data);
	const isLoading = (isPortfoliosLoading || isPropertiesLoading) && !hasData;

	return {
		portfolios,
		properties,
		reporting,
		isLoading,
	};
};
